var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-space-between"},[_c('go-back-button'),_c('div',{staticClass:"d-flex"},[_c('download-button',{staticClass:"mr-2"}),_c('share-button')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }